<template>
  <div class="social-proof">
    <div class="social-proof__wrapper-inner">
      <div class="social-proof__images">
        <div
          v-for="media of product.socialProof.images"
          :key="media.id"
          class="social-proof__image-container"
        >
          <responsive-image
            class="social-proof__image"
            :image="media.image"
            ratio="1:1"
            sizes="48px"
            widths="48, 96, 144, 192"
          />
        </div>
      </div>
      <span
        class="social-proof__text text-mobile-paragraph-s-regular"
        v-text="product.socialProof.text"
      />
    </div>
  </div>
</template>

<script>
import ResponsiveImage from '~global/images/responsive-image.vue';

/**
 * Vue: Social proof (social-proof)
 * -----------------------------------------------------------------------------
 * Shows a hint about product endorsements by influencers and total sales.
 * - Component settings: snippet / dynamic / async / scroll
 *
 */
export default {
  name: 'SocialProof',

  components: {
    ResponsiveImage,
  },

  props: {
    product: {
      type: [Boolean, Object],
      default: false,
      required: true,
    },
  },
};
</script>

<style lang="scss">
@import './social-proof';
</style>
